require('./bootstrap');

// Make Bootstrap available globally
import 'bootstrap';
window.bootstrap = require('bootstrap');
